<template>
  <div>
    <!-- Page length options -->
    <div class="card mb-0">
      <div 
        v-show="onload" 
        class="content bg-white"
      >
        <placeholder-content is-load="true" />
      </div>
      <div v-if="!onload && hasPermission">
        <access-denied />
      </div>
      <div 
        v-show="!onload && !hasPermission" 
        class="card-header border-bottom"
      >
        <div class="row">
          <div class="col-6">
            <h5 class="card-title">
              {{ $t("Billing details") }}
            </h5>
          </div>
          <div class="col-6 text-right">
            <button 
              class="btn btn-primary" 
              @click="handleDownload"
            >
              <i class="fa-solid fa-file-arrow-down" /> {{ $t("Download") }}
            </button>
          </div>
        </div>
      </div>
      <div 
        v-show="!onload && !hasPermission" 
        class="card-body p-0"
      >
        <div>
          <div class="flex-wrap pl-3 pt-3">
            <overview-detail />
          </div>
          <div class="flex-wrap">
            <detail-table />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/services/endpoint/tenant.service";
import moment from "moment";
import VueJsCounter from "@/plugins/VueJsCounter";
import { convertTimezone } from "@/common/tenancy/convertTimezone";
import PlaceholderContent from "@/plugins/PlaceholderContent.vue";
import DetailTable from "./DetailTable.vue";
import OverviewDetail from "./OverviewDetail.vue";
import { tHeader, filterVal } from "../assets/js/xlsx.js";
import numeral from "numeral";
import AccessDenied from "@/components/tenancy/admin/error-page/templates/AccessDenied.vue";
export default {
  name: 'DetailCod',
  components: {
    PlaceholderContent,
    DetailTable,
    OverviewDetail,
    AccessDenied,
  },
  data() {
    return {
      hasPermission: true,
      onload: true,
      isLoaded: true,
      percentage: 100,
      since_text: "Since last month",
      duration: 2000,
      tHeader: null,
      filterVal: null,
      list: null,
      filename: "COD Export - Goship",
      autoWidth: true,
      bookType: "xlsx",
      paramsQuery: {
        search: null,
        start_date: null,
        end_date: null,
        per_page: 10,
        current_page: 1,
        sort: "",
        page: 1,
        reportType: "all",
      },
    };
  },
  computed: {},
  methods: {
    async handleDownload() {
      let postHasPermission = await Api.Permission.postHasPermission(
        "payment_report_by_cod_download"
      );
      if (postHasPermission.data.status) {
        let id = this.$route.params.id;
        const codAccountId = this.$route.params.cod_account_id;
        this.fetchData(id, codAccountId);
      } else {
        var titleMessage = this.$t("Access Denied");
        var htmlMessage = this.$t(
          "You do not have permission to access this page."
        );
        var self = this;
        this.$swal.fire({
          title: titleMessage,
          icon: "warning",
          iconColor: "#FF7043",
          html: htmlMessage,
          showCancelButton: true,
          confirmButtonText:
            '<i class="fas fa-redo mr-2"></i>' + self.$t("Try again"),
          cancelButtonText: this.$t("Cancel"),
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-primary mr-2",
            cancelButton: "btn btn-light",
            loader: "custom-loader",
          },
          loaderHtml: '<div class="spinner-border text-primary"></div>',
          focusConfirm: false,
          showLoaderOnConfirm: true,
          preConfirm: async function () {
            return await Api.Permission.postHasPermission(
              "payment_report_by_cod_download"
            ).then((response) => {
              if (response.data.status) {
                let id = self.$route.params.id;
                self.fetchData(id, codAccountId);
              } else {
                self.$swal.showValidationMessage(self.$t("Permission denied."));
              }
            });
          },
        });
      }
    },
    async permissionDownload() {},
    fetchData(id, codAccountId) {
      let queryString = "";
      if (this.paramsQuery) {
        if (this.paramsQuery.start_date && this.paramsQuery.end_date) {
          let startDate = this.paramsQuery.start_date
            ? moment(this.paramsQuery.start_date).format("YYYY-MM-DD")
            : null;
          let endDate = this.paramsQuery.end_date
            ? moment(this.paramsQuery.end_date).format("YYYY-MM-DD")
            : null;

          var afterStartDate = startDate + " 00:00:00";
          var afterEndDate = endDate + " 23:59:59";

          this.paramsQuery.start_date =
            convertTimezone.localToUtc(afterStartDate);
          this.paramsQuery.end_date = convertTimezone.localToUtc(afterEndDate);
        }
      }

      if (this.paramsQuery) {
        queryString += "?" + $.param(this.paramsQuery);
      }

      Api.Report.getCodReconcileView(
        "?" +
          $.param({
            search: "",
            start_date: this.paramsQuery.start_date,
            end_date: this.paramsQuery.end_date,
            per_page: 5000,
            current_page: this.paramsQuery.current_page,
            sort: this.paramsQuery.sort,
            page: this.paramsQuery.page,
            reportType: this.paramsQuery.reportType,
          }),
        id,
        codAccountId
      ).then((response) => {
        // Api.Report.getCodReconcileView(queryString,id).then(response => {
        this.list = response.data.data;
        import("../assets/js/Export2Excel.js").then((excel) => {
          const tHeader = this.tHeader;
          const filterVal = this.filterVal;
          const list = this.list;
          const data = this.formatJson(filterVal, list);
          data.forEach((element, index) => {
            element[1] = element[1]
              ? convertTimezone.utcToLocal(element[1])
              : "-";
            element[2] = element[2]
              ? convertTimezone.utcToLocal(element[2])
              : "-";
            element[7] = numeral(element[9] == 1 ? (list[index].total_deduct * -1) : element[7]).format("0,0.00");
            element[8] = numeral(element[8]).format("0,0.00");
            element[9] = element[9] == 1 ? 'Tracking Deduct' : '-';
          });
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType,
          });
        });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          const jArr = j.split(".");
          if (jArr.length > 1) {
            return v[jArr[0]][[jArr[1]]];
          }

          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
  },
  async mounted() {
    this.onload = true;
  },
  created() {
    this.tHeader = tHeader();
    this.filterVal = filterVal();
  },
};
</script>
<style>
.header-title {
  margin-bottom: 0.1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/report/finance/Detail.vue